import { ref, computed } from 'vue';
import { computedWithControl } from '@vueuse/core';

import { calcDatesRangeSafe, getTodayDayJs, pickerDayToUtcDateStr } from '@/components/common/dateUtils';


export const useDateRangeAdapter = (sessionStore, defaultDaysDeltaStart, defaultDaysDeltaEnd) => {
	const datesRange = computedWithControl(
		[
			() => sessionStore.chartDatesRange,
			() => sessionStore.chartDatesRangeUpdated,
		],
		{
			get: () => {
				sessionStore.checkChartDatesRangeAccess();
				if (sessionStore.chartDatesRange == null && !sessionStore.chartDatesRangeUpdated) {
					const today = getTodayDayJs();
					return [today.subtract(defaultDaysDeltaStart, 'day'), today.subtract(defaultDaysDeltaEnd, 'day')];
				}
				return sessionStore.chartDatesRange;
			},
			set: value => sessionStore.updateChartDatesRange(value),
		},
	);

	const datesRangeStr = computed(() => {
		if (datesRange.value == null) {
			return null;
		}
		return datesRange.value.map(pickerDayToUtcDateStr);
	});

	const dateRangeSafeStart = ref(null);
	const dateRangeSafeEnd = ref(null);

	const datesRangeSafe = computed(() => {
		// этот механизм нужен, чтобы только при первом обращении могли быть null в ответе
		// в остальных случаях при обнулении выдаем последние значения
		// это чтобы при нажатии на крестик в диапазоне дат, график не обновлялся на авто-диапазон
		if (datesRange.value != null) {
			const [safeStart, safeEnd] = calcDatesRangeSafe(datesRange.value);
			dateRangeSafeStart.value = safeStart;
			dateRangeSafeEnd.value = safeEnd;
		}
		return [dateRangeSafeStart.value, dateRangeSafeEnd.value];
	});

	const rangeDays = computed(() => {
		return Math.round((datesRangeSafe.value[1] - datesRangeSafe.value[0]) / (24 * 60 * 60 * 1000));
	});

	return { datesRange, datesRangeStr, datesRangeSafe, rangeDays };
};


export const useLocalDateRange = (defaultDaysDeltaStart, defaultDaysDeltaEnd) => {
	const today = getTodayDayJs();
	const datesRange = ref([
		today.subtract(defaultDaysDeltaStart, 'day'),
		today.subtract(defaultDaysDeltaEnd, 'day'),
	]);

	const datesRangeStr = computed(() => {
		if (datesRange.value == null) {
			return null;
		}
		return datesRange.value.map(pickerDayToUtcDateStr);
	});

	const dateRangeSafeStart = ref(null);
	const dateRangeSafeEnd = ref(null);

	const datesRangeSafe = computed(() => {
		if (datesRange.value != null) {
			const [safeStart, safeEnd] = calcDatesRangeSafe(datesRange.value);
			dateRangeSafeStart.value = safeStart;
			dateRangeSafeEnd.value = safeEnd;
		}
		return [dateRangeSafeStart.value, dateRangeSafeEnd.value];
	});

	const rangeDays = computed(() => {
		return Math.round((datesRangeSafe.value[1] - datesRangeSafe.value[0]) / (24 * 60 * 60 * 1000));
	});

	return { datesRange, datesRangeStr, datesRangeSafe, rangeDays };
};
